import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { OtpVerificationStateService } from '../../services/otp-verification-state-service/otp-verification-state.service';

@Injectable({ providedIn: 'root' })
export class OtpVerificationGuard implements CanActivate {
  constructor(
    private _otpState: OtpVerificationStateService,
    private _router: Router
  ) {}

  public canActivate(): boolean {
    if (this._otpState.isVerified) {
      return true;
    }
    this._router.navigate(['/import-files'], {
      queryParams: { verificationRequired: true },
    });
    return false;
  }
}
